import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import "../style.scss";
import ZeroScreen from "../zero-screen";
import { getCumulativeSum } from "../../../../helpers/accounting-helper";
import SortFilter from "../sort-filter";
import { ACCOUNT_SUMMARY, GROUP_BY_TYPES, SORT_VALUE_TYPES } from "../../../../data/constants";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { isMobileTabDevice } from "../../../../helpers/device-info-helper";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useDispatch } from "react-redux";
import { fetchCommonData, getSaleGroupByBrand} from "../../../../redux/slices";
import { METHODS } from "../../../../data/api-method-constants";
import { ENDPOINT } from "../../../../services/apiUrls";
import { toastError } from "../../../../utils/react-toaster";
import { getErrorMessage, pos_errormap_without_label } from "../../../../helpers/errors-helper";
import SaleSummary, { renderAccordionHeader } from "./sale-summary";
import { Accordion, AccordionDetails } from "../../../../components/reusable-ui/material-ui-comp/accordion";
import { AccordionSummary } from "@mui/material";
import { cloneDeep } from "lodash";
import { renderGroupByBranch, renderSaleSummaryLeftHeader } from "../../../../helpers/sale-summary-model";

function SalesSummary({hideFilterMobile, showFilterResults, periods, groupBy, dataToPost, invoiceSummary}:any) {
  const [showSummaryDetails, setShowSummaryDetails] = useState<any>({});
  const [brandsData, setBrandsData] = useState<any>([]);
  const [summaryDetailsResponse,setSummaryDetailsResponse] = useState<any>({});
  const [selectedBranchId, setSelectedBranchId] = useState<any>({});
  const [selectedOptionSet, setOptionSet] = useState<any>({});
  const [expanded, setExpanded] = useState(false);
  const brandsDataMap = useSelector(
    (state: RootState) => state.accountingReducer?.accountingSummary || []
  );
  const groupBybrandsDataMap = useSelector(
    (state: RootState) => state.accountingReducer?.salesSummaryByBrand || []
  );
  const { businessBranchesDataMap } = useSelector((state: any) => ({
    businessBranchesDataMap: state.businessReducer.businessBranchesDataMap,
  }));
 const dispatch = useDispatch();

  const dropdownItems = [
    {
      key: "amountl2h",
      label: "Amount (Low to High)",
      getKey: (val: any) => {
        return val.netSaleAmount;
      },
      type: SORT_VALUE_TYPES.number,
      class: "ic-sort-increasing",
    },
    {
      key: "amounth2l",
      label: "Amount (High to Low)",
      getKey: (val: any) => {
        return -val.netSaleAmount;
      },
      type: SORT_VALUE_TYPES.number,
      class: "ic-sort-decreasing"
    },
    {
      key: "branchname",
      label: "Branch Name",
      getKey: (val: any) => {
        return (
          businessBranchesDataMap[val?.branchId]?.branchName ||
          val?.bizBrandName
        );
      },
      type: SORT_VALUE_TYPES.string,
      class:"ic-sort-branch"
    },
  ];

  useEffect(() => {
    if (brandsDataMap?.length > 0) setBrandsData(brandsDataMap);
  }, [brandsDataMap]);

  useEffect(() => {
    setShowSummaryDetails("");
  }, [brandsDataMap, groupBybrandsDataMap]);

  function getSalesDetails(brand: any) {
    dispatch(
      fetchCommonData({
        method: METHODS.POST,
        url: ENDPOINT.ACCOUNTING.getSalesSummary,
        body: {
          branchIds: [brand?.branchId],
          periods: periods,
        },
        callback: salesCallback,
      })
    );
  }

  function salesCallback(res: any) {
    if (!res.code) {
      setSummaryDetailsResponse(res);
    } 
  }

  function handleBrandSelectionChange(e: any, option:any){
    setSelectedBranchId(option);
    setShowSummaryDetails(option);
    getSalesDetails(option);
    hideFilterMobile(option);
    e.stopPropagation();
  }

  function renderSalesByBrand(options: any) {
    return options.map((option: any, i: number) => {
      return (
        <section
          className={`p-16 pl-50 hover:shadow-[0px_2px_4px_#00000014] relative flex items-center cursor-pointer w-full border-b-[1px]  border-b-[#ECECEC] menu-item-details 
                  ${
                    selectedBranchId?.branchId === option?.branchId
                      ? "bg-[#0000001a] border-l-[3px] border-l-[#000]"
                      : ""
                  }
                `}
          key={i}
          onClick={(e) => handleBrandSelectionChange(e, option)}
        >
          <div className="flex flex-col w-[100%]">
            <div className="flex !justify-between pr-10">
              <p className="text-15">
                {businessBranchesDataMap[option?.branchId]?.branchName}
              </p>
              <div className="text-[14px] text-[#3A5E8B]">
                <span>Net Revenue:</span>
                <span className="ml-5 font-semibold">
                  ₹{Number(option?.netSaleAmount).toFixed(2)}
                </span>
              </div>
            </div>
            <div className="flex !justify-between pr-10">
              <div className={`text-[13px] text-[#0000007A]`}>
                <span>{option?.saleCount}</span>
                <span className="ml-2">Orders</span>
              </div>
              <div className="text-[13px] text-[#0000007A]">
                <span>Sales Item Revenue:</span>
                <span className="text-[#000000B2] ml-5">
                  ₹{Number(option?.grossSaleAmount).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </section>
      );
    });
  }

  const handleOptionSetChange =
    (panel: any) => (event: React.SyntheticEvent, newExpanded: boolean) => {
      event.stopPropagation();
      setOptionSet(newExpanded ? panel : false);
      let payloadData = cloneDeep(dataToPost)
      delete payloadData.groupBy;
      delete payloadData.bizzBrandNames;
      payloadData.groupByBrand = true;
      payloadData.bizzBrandNames = [panel?.bizBrandName];
      dispatch(getSaleGroupByBrand(payloadData));
      setExpanded((prevExpanded) => !prevExpanded);
    };

  function renderBrandsList(brandsList: any): JSX.Element {
    return (
      !!brandsList?.length &&
      brandsList.map((brand: any, index: number) => {
        //condition to check selected data
        let isSelected =
        (brand.bizBrandName &&
          showSummaryDetails.bizBrandName === brand.bizBrandName) ||
        (brand.branchId &&
          showSummaryDetails.branchId === brand.branchId);
        return (
          <>
            {groupBy === GROUP_BY_TYPES.brand ? (
              <>
                <Accordion
                  key={brand}
                  TransitionProps={{ unmountOnExit: true }}
                  expanded={selectedOptionSet === brand}
                  onChange={handleOptionSetChange(brand)}
                >
                  <AccordionSummary
                    className={`accordion-header p-[16px] flex justify-between ${
                      selectedOptionSet === brand ? "active" : ""
                    }`}
                    aria-controls="branch-data"
                    id={brand}
                  >
                    {expanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
                    {renderAccordionHeader({
                      headerName: brand?.bizBrandName,
                      options: brand,
                      isSelected: selectedOptionSet === brand,
                      groupBy: groupBy,
                    })}
                  </AccordionSummary>

                  {brand?.bizBrandName !== null && (
                    <AccordionDetails className="!m-0">
                      {renderSalesByBrand(groupBybrandsDataMap)}
                    </AccordionDetails>
                  )}
                </Accordion>
              </>
            ) : (
              <div
                className={`brand-item flex items-center pb-[16px] relative cursor-pointer p-[16px] ${
                  isSelected
                    ? "bg-black/5 border-l-[4px] !border-black "
                    : " border-[#ECECEC] border-t-[1px]  last:border-b"
                }`}
                key={index}
                onClick={(e) => {
                  setShowSummaryDetails(brand);
                  getSalesDetails(brand);
                  hideFilterMobile(brand);
                  e.stopPropagation();
                }}
              >
                {renderGroupByBranch(brand, isSelected, businessBranchesDataMap)}
              </div>
            )}
          </>
        );
      })
    );
  }
  function renderSaleSummary(): JSX.Element {
    let isRenderSaleSummary =
      (isMobileTabDevice() &&
        !showSummaryDetails &&
        showSummaryDetails.length !== 0) ||
      !isMobileTabDevice();
    return (
      <div className={`flex smd:flex-col smd:overflow-y-auto`}>
        <div className="w-[40%] smd:w-[100%] border-r-[1px] smd:border-none smd:!ml-0 smd:mt-0 mt-12 ml-16 bg-white">
          {((Object.keys(showSummaryDetails).length === 0 &&
            isMobileTabDevice()) ||
            !isMobileTabDevice()) && (
            <>{renderSaleSummaryLeftHeader(brandsDataMap)}</>
          )}
          {isRenderSaleSummary && (
            <div className="text-[#0000007A] bg-white text-14 items-center px-16 py-12 flex justify-between">
              <div className="font-semibold">
                {groupBy === GROUP_BY_TYPES.brand ? "Brands:" : "Branches:"}
                {brandsDataMap?.length}
              </div>
              <SortFilter
                dataToSort={brandsDataMap}
                handleSort={setBrandsData}
                sortOptionsMap={dropdownItems}
              />
            </div>
          )}
          {(!Object.keys(showSummaryDetails).length ||
            !isMobileTabDevice()) && (
            <div
              className={`h-[calc(100vh-312px)] smd:overflow-y-auto ${
                groupBy === GROUP_BY_TYPES.brand && "border-t-[1px]"
              } pb-[8px] bg-[#fff]`}
            >
              {renderBrandsList(brandsData ? Object.values(brandsData) : [])}
            </div>
          )}
        </div>
        <div className="w-[60%] smd:w-[100%] bg-white mt-12 smd:mt-0 mr-16 smd:!p-4">
          {Object.keys(showSummaryDetails).length > 0 ? (
            Object.keys(summaryDetailsResponse).length > 0 ? (
              <SaleSummary
                summaryDetailsResponse={summaryDetailsResponse}
                handleSummaryDetails={setShowSummaryDetails}
                hideFilterMobile={hideFilterMobile}
              />
            ) : (
              <ZeroScreen summaryDetailsResponse={true} />
            )
          ) : (
            !isMobileTabDevice() && (
              <ZeroScreen
                showSummaryDetails={showSummaryDetails.length !== 0}
                summaryType={ACCOUNT_SUMMARY.sales.id}
              />
            )
          )}
        </div>
      </div>
    );
  }
  return (
    <>
      {brandsDataMap.length !== 0 ? (
       renderSaleSummary()
      ) : (
        <ZeroScreen showFilterResults={showFilterResults}/>
      )}
    </>
  );
}

export default SalesSummary;
